import { Injectable } from '@angular/core';
import { deserializeJson, serializeJson } from './json-date-serialization';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  set(key: string, value: unknown) {
    localStorage.setItem(key, serializeJson(value));
  }

  get<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    return item ? deserializeJson<T>(item) : null;
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }
}
